import { useEffect, useState } from 'react';
import './App.css';

const ArrowUpRight = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M7 17 17 7M8 7h9v9" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ChevronDown = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="m6 9 6 6 6-6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const BirdMark = ({ compact = false }) => (
  <span className={`brand-mark ${compact ? 'brand-mark--compact' : ''}`} aria-hidden="true">
    <svg viewBox="0 0 40 40" fill="none">
      <path d="M8 29.5c5.1-1.2 8.5-4.3 10.4-9.4 1.5-4 4.6-6.6 9.5-7.8-1.5 3.2-1.6 6.3-.2 9.3 1.4 3.1 1 6.3-1.1 9.7-4.4-3.1-8.2-4.1-11.5-3.1-2 .6-4.4 1-7.1 1.3Z" fill="currentColor" />
      <circle cx="27.8" cy="12.2" r="1.4" fill="#07100d" />
    </svg>
  </span>
);

const avlakScreens = [
  { src: '/images/avlak-anasayfa.png', alt: 'Avlak uygulaması ana sayfa ve topluluk akışı' },
  { src: '/images/avlak-harita.png', alt: 'Avlak uygulaması harita ve saha paylaşımları ekranı' },
  { src: '/images/avlak-profil.png', alt: 'Avlak uygulaması avcı profili ve rozetler ekranı' },
  { src: '/images/avlak-yeni-gonderi.png', alt: 'Avlak uygulaması yeni gönderi oluşturma ekranı' },
];

// Mağaza sayfaları yayınlandığında bağlantıları buraya ekleyin.
const avlakStoreLinks = {
  ios: 'https://apps.apple.com/tr/app/avlak-avc%C4%B1l%C4%B1k-platformu/id6794712910',
  android: '',
};

const AppleIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path fill="currentColor" d="M17.1 12.5c0-2.8 2.3-4.2 2.4-4.3a5.1 5.1 0 0 0-4-2.2c-1.7-.2-3.3 1-4.1 1s-2.1-1-3.5-.9a5.2 5.2 0 0 0-4.4 2.7c-1.9 3.3-.5 8.1 1.3 10.8.9 1.3 2 2.8 3.4 2.7 1.4-.1 1.9-.9 3.5-.9s2.1.9 3.6.9c1.5 0 2.4-1.3 3.3-2.7a12 12 0 0 0 1.5-3.1 4.7 4.7 0 0 1-3-4Zm-2.7-8.3A4.8 4.8 0 0 0 15.5.7a4.9 4.9 0 0 0-3.2 1.6 4.5 4.5 0 0 0-1.1 3.4 4.1 4.1 0 0 0 3.2-1.5Z" />
  </svg>
);

const PlayIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path fill="currentColor" d="M3.6 2.4a2 2 0 0 0-.4 1.2v16.8c0 .5.2.9.5 1.2l9.2-9.6-9.3-9.6Zm10.6 8.3 2.4-2.5L6.1 2.3l8.1 8.4Zm0 2.6-8 8.4 10.4-5.9-2.4-2.5Zm3.9-4.2L15.5 12l2.6 2.8 2.3-1.3c.8-.5.8-1.5 0-2l-2.3-1.4Z" />
  </svg>
);

const StoreButton = ({ platform, href }) => {
  const content = (
    <>
      {platform === 'ios' ? <AppleIcon /> : <PlayIcon />}
      <span><small>{href ? 'ŞİMDİ İNDİR' : 'YAKINDA'}</small><strong>{platform === 'ios' ? 'App Store' : 'Google Play'}</strong></span>
    </>
  );

  return href ? (
    <a className="store-button" href={href} target="_blank" rel="noreferrer" aria-label={`${platform === 'ios' ? 'App Store' : 'Google Play'} üzerinden indir`}>{content}</a>
  ) : (
    <span className="store-button store-button--disabled" aria-label={`${platform === 'ios' ? 'App Store' : 'Google Play'} bağlantısı yakında`} aria-disabled="true">{content}</span>
  );
};

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeScreen, setActiveScreen] = useState(null);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (activeScreen === null) return undefined;
    const closeWithEscape = (event) => {
      if (event.key === 'Escape') setActiveScreen(null);
    };
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', closeWithEscape);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', closeWithEscape);
    };
  }, [activeScreen]);

  const closeMenu = () => setMenuOpen(false);

  return (
    <main>
      <nav className={scrolled ? 'nav nav--scrolled' : 'nav'} aria-label="Ana menü">
        <a href="#top" className="logo" onClick={closeMenu} aria-label="Onur Rahmi Özdemir ana sayfa">
          <img className="logo-mark" src="/images/onur-logo-mark-v2.png" alt="" />
          <span>ONUR ÖZDEMİR</span>
        </a>

        <button
          className={`menu-toggle ${menuOpen ? 'menu-toggle--open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-expanded={menuOpen}
          aria-label="Menüyü aç veya kapat"
        >
          <span />
          <span />
        </button>

        <div className={`nav-links ${menuOpen ? 'nav-links--open' : ''}`}>
          <a href="#products" onClick={closeMenu}>Ürünler</a>
          <a href="#approach" onClick={closeMenu}>Yaklaşımımız</a>
          <a className="nav-cta" href="mailto:contact@onurrahmiozdemir.com" onClick={closeMenu}>
            İletişime geç <ArrowUpRight size={16} />
          </a>
        </div>
      </nav>

      <header className="hero" id="top">
        <div className="hero-grid" aria-hidden="true" />
        <div className="hero-orbit hero-orbit--one" aria-hidden="true" />
        <div className="hero-orbit hero-orbit--two" aria-hidden="true" />
        <div className="hero-content">
          <div className="eyebrow"><span /> Bağımsız yazılım geliştirici</div>
          <h1>Fikirlerimi,<br /><em>kullanışlı dijital</em><br />ürünlere dönüştürüyorum.</h1>
          <p className="hero-copy">
            Ben Onur Rahmi Özdemir. Gerçek ihtiyaçlardan yola çıkan, sade ve kullanışlı uygulamalar tasarlıyor ve geliştiriyorum.
          </p>
          <a className="primary-button" href="#products">
            Ürünlerimizi keşfet <span><ChevronDown /></span>
          </a>
        </div>

        <div className="hero-showcase" aria-label="Mobil ve web ürünleri önizlemesi">
          <div className="showcase-glow" aria-hidden="true" />
          <div className="hero-laptop">
            <div className="laptop-browser-bar">
              <span /><span /><span />
              <div>avlak.app</div>
            </div>
            <div className="laptop-screen">
              <img src="/images/avlak-harita.png" alt="Avlak harita ekranı web görünümü" />
              <div className="laptop-overlay">
                <small>AVLAK · HARİTA</small>
                <strong>Doğayı keşfet.</strong>
              </div>
            </div>
            <div className="laptop-base" />
          </div>

          <div className="hero-phone">
            <div className="hero-phone-notch" />
            <img src="/images/avlak-anasayfa.png" alt="Avlak mobil uygulaması ana ekranı" />
          </div>

          <div className="showcase-label showcase-label--web"><i /> WEB DENEYİMİ</div>
          <div className="showcase-label showcase-label--mobile"><i /> MOBİL UYGULAMA</div>
          <div className="showcase-chip">
            <BirdMark compact />
            <div><strong>Avlak</strong><small>Yayında · avlak.app</small></div>
          </div>
        </div>

        <div className="hero-side-note" aria-hidden="true">
          <span>DESIGN</span><i /> <span>BUILD</span><i /> <span>SHIP</span>
        </div>
      </header>

      <section className="products section" id="products">
        <div className="section-heading">
          <div>
            <span className="section-index">01 / ÜRÜNLERİMİZ</span>
            <h2>Geliştirdiğim<br />uygulamalar.</h2>
          </div>
          <p>Her projeyi gerçek bir ihtiyaca çözüm olmak için geliştiriyorum. Burada yayındaki ve üzerinde çalıştığım uygulamaları bulabilirsiniz.</p>
        </div>

        <article className="product-card">
          <div className="product-info">
            <div className="product-number">01</div>
            <div className="product-logo">
              <BirdMark />
              <span>AVLAK</span>
            </div>
            <h3>Avcıların dijital<br />buluşma noktası.</h3>
            <p>Avlakları keşfet, deneyimlerini paylaş ve doğaya tutkuyla bağlı bir topluluğun parçası ol.</p>
            <div className="product-tags">
              <span>Mobil Uygulama</span>
              <span>Topluluk</span>
              <span>Harita</span>
            </div>
            <div className="store-buttons" aria-label="Avlak uygulamasını indir">
              <StoreButton platform="ios" href={avlakStoreLinks.ios} />
              <StoreButton platform="android" href={avlakStoreLinks.android} />
            </div>
            <a href="https://avlak.app" target="_blank" rel="noreferrer" className="product-link">
              avlak.app'i ziyaret et <ArrowUpRight />
            </a>
          </div>

          <div className="product-visual" aria-label="Avlak uygulaması ekran görüntüleri">
            <div className="terrain-lines" />
            <div className="sun-disc" />
            <div className="screen-gallery">
              {avlakScreens.map((screen, index) => (
                <button
                  className={`screen-shot screen-shot--${index + 1}`}
                  key={screen.src}
                  onClick={() => setActiveScreen(index)}
                  aria-label={`${screen.alt} — büyüt`}
                >
                  <img src={screen.src} alt={screen.alt} loading={index > 1 ? 'lazy' : 'eager'} />
                </button>
              ))}
            </div>
            <div className="visual-caption">GERÇEK UYGULAMA<br /><strong>EKRANLARI.</strong></div>
            <div className="gallery-hint">BÜYÜTMEK İÇİN TIKLA ↗</div>
          </div>
        </article>

        <article className="product-card product-card--bises">
          <div className="product-info bises-info">
            <div className="product-number">02</div>
            <div className="product-logo bises-logo" aria-label="bises">
              <span className="bises-mark" aria-hidden="true"><i /></span>
              <span>bises</span>
              <small>BETA</small>
            </div>
            <h3>Topluluğun için<br />tek bir buluşma alanı.</h3>
            <p>Ekibinle yazış, topluluğunu yönet ve düşük gecikmeli sesli odalarda bir araya gel. Bises; web ve masaüstünde güvenli, akıcı bir iletişim deneyimi sunar.</p>
            <div className="product-tags">
              <span>Web & Masaüstü</span>
              <span>Topluluk</span>
              <span>Sesli Odalar</span>
            </div>
            <a href="https://bises.app" target="_blank" rel="noreferrer" className="bises-visit-button">
              bises.app'e git <ArrowUpRight />
            </a>
          </div>

          <div className="product-visual bises-visual" aria-label="bises.app uygulaması ekran görüntüsü">
            <div className="bises-glow" aria-hidden="true" />
            <div className="bises-browser">
              <div className="bises-browser-bar">
                <span /><span /><span />
                <div>bises.app</div>
              </div>
              <img src="/images/bises-app.png" alt="bises uygulamasının topluluk, mesajlaşma ve sesli oda özelliklerini gösteren ekran" loading="lazy" />
            </div>
            <div className="bises-caption"><span>GERÇEK UYGULAMA</span><strong>EKRANI.</strong></div>
          </div>
        </article>

        <div className="coming-soon">
          <span className="coming-number">03</span>
          <div><strong>Yeni uygulamalar yolda.</strong><p>Sıradaki fikrim üzerinde çalışıyorum.</p></div>
          <div className="pulse"><i /><span>GELİŞTİRİLİYOR</span></div>
        </div>
      </section>

      <section className="approach section" id="approach">
        <div className="approach-intro">
          <span className="section-index">02 / YAKLAŞIMIMIZ</span>
          <h2>Sade düşünür,<br /><em>özenle geliştiririm.</em></h2>
        </div>
        <div className="principles">
          <div><span>01</span><h3>Yalınlık</h3><p>Karmaşık süreçleri anlaşılır hale getirir, üründe gerçekten ihtiyaç duyulan özelliklere odaklanırım.</p></div>
          <div><span>02</span><h3>Özen</h3><p>Tasarımdan koda kadar her ayrıntıyla doğrudan ilgilenir, tutarlı bir deneyim oluşturmaya çalışırım.</p></div>
          <div><span>03</span><h3>Gelişim</h3><p>Uygulamaları yayınladıktan sonra kullanıcı geri bildirimleriyle düzenli olarak iyileştiririm.</p></div>
        </div>
      </section>

      <footer>
        <div className="footer-main">
          <div className="footer-wordmark"><img className="logo-mark" src="/images/onur-logo-mark-v2.png" alt="" />ONUR ÖZDEMİR</div>
          <div className="footer-cta"><span>MERHABA DEYİN</span><a href="mailto:contact@onurrahmiozdemir.com">contact@onurrahmiozdemir.com <ArrowUpRight size={26} /></a></div>
        </div>
        <div className="footer-bottom"><span>© 2026 ONUR RAHMİ ÖZDEMİR</span><span>ŞAHIS İŞLETMESİ · TÜRKİYE</span><a href="#top">YUKARI DÖN ↑</a></div>
      </footer>

      {activeScreen !== null && (
        <div className="screen-modal" role="dialog" aria-modal="true" aria-label="Avlak ekran görüntüsü önizlemesi" onClick={() => setActiveScreen(null)}>
          <button className="modal-close" onClick={() => setActiveScreen(null)} aria-label="Önizlemeyi kapat">×</button>
          <button
            className="modal-arrow modal-arrow--left"
            onClick={(event) => { event.stopPropagation(); setActiveScreen((activeScreen + avlakScreens.length - 1) % avlakScreens.length); }}
            aria-label="Önceki ekran"
          >←</button>
          <img
            src={avlakScreens[activeScreen].src}
            alt={avlakScreens[activeScreen].alt}
            onClick={(event) => event.stopPropagation()}
          />
          <button
            className="modal-arrow modal-arrow--right"
            onClick={(event) => { event.stopPropagation(); setActiveScreen((activeScreen + 1) % avlakScreens.length); }}
            aria-label="Sonraki ekran"
          >→</button>
          <span className="modal-count">{activeScreen + 1} / {avlakScreens.length}</span>
        </div>
      )}
    </main>
  );
}

export default App;
